<app-deprecated-confirmation-dialog
    #confirmDeleteDialog
    [description]="deleteMessage | translate: { numberOfEmployees: program?.enrolledCount }"
    label="{{ 'delete' | translate }}"
    [header]="'training.deleteModalTitle' | translate: { name: program?.name }"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="{{ 'training.training' | translate }}" [menuService]="trainingModuleMenuService">
        <div class="buttons">
            <ui-button *ngIf="!isEmpty" type="primary" url="new"
                ><mat-icon svgIcon="plus"></mat-icon>{{ 'training.createTrainingProgram' | translate }}</ui-button
            >
        </div>
    </app-header>

    <app-table [table]="table" (menuItemSelected)="menuAction($event)" *ngIf="!isEmpty; else emptyState">
        <app-empty-state
            label="{{ 'training.noTrainingProgramsFound' | translate }}"
            src="/assets/illustrations/chair.png"
        ></app-empty-state>
    </app-table>

    <ng-template #emptyState>
        <div class="ui segment" style="position: relative">
            <div class="sub header empty-state">{{ 'training.noTrainingProgramsCreated' | translate }}</div>
            <div class="ui centered header" style="margin-bottom: 70px">
                <ui-button type="primary" url="new"
                    ><mat-icon svgIcon="plus"></mat-icon>{{ 'training.createTrainingProgram' | translate }}</ui-button
                >
            </div>
        </div>
    </ng-template>
</div>
